export default "__VITE_ASSET__CQ6vW5mJ__"